var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComparelist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#ED2A30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.825 18.15C27.3591 18.15 22.0687 25.2038 22.0687 33.825H18.15L24.0281 44.275L29.9062 33.825H25.9875C25.9875 28.0253 29.4752 23.375 33.825 23.375V18.15ZM43.6219 23.375L37.7437 33.825H41.6625C41.6625 39.6248 38.1748 44.275 33.825 44.275V49.5C40.2909 49.5 45.5812 42.4463 45.5812 33.825H49.5L43.6219 23.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparelist);
export default __webpack_public_path__ + "static/media/comparelist.8a71e7652c848ebb3721ea02c9231cc5.svg";
export { ForwardRef as ReactComponent };